import { render, staticRenderFns } from "./WritePaperContent.vue?vue&type=template&id=1044b16c"
import script from "./WritePaperContent.vue?vue&type=script&lang=js"
export * from "./WritePaperContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports